{
  "intro": "Add or change many products at once with a spreadsheet file (CSV). The file is checked first — nothing is saved until you press “Import”.",
  "tabs": {
    "import": "Import a file",
    "export": "Download products",
    "history": "Earlier imports"
  },
  "steps": {
    "upload": "1. Choose the file",
    "mapping": "2. Which column is what",
    "check": "3. Check",
    "import": "4. Import"
  },
  "upload": {
    "title": "Choose a CSV file",
    "drop": "Drop the file here, or",
    "choose": "Choose a file",
    "hint": "Excel: “Save as → CSV UTF-8”. Up to 20 MB.",
    "too_large": "This file is {{size}} MB — the most is 20 MB. Split it into smaller files (for example by game) and import them one after the other.",
    "not_csv": "This is not a CSV file. In Excel choose “Save as → CSV UTF-8 (comma delimited)”.",
    "empty": "This file has no rows.",
    "reading": "Reading the file…",
    "templates": "Empty files to fill in",
    "templates_hint": "Download a file in the right layout, delete the example rows and fill in yours.",
    "template_native": "Full layout (every field)",
    "template_shopify": "Shopify layout",
    "template_quick_cards": "Quick card list (game, set, number, Rank, price)"
  },
  "profiles": {
    "native": "Full layout of this shop",
    "shopify": "Shopify export",
    "quick_cards": "Quick card list"
  },
  "mapping": {
    "detected": "This looks like: {{profile}}",
    "not_detected": "The layout was not recognised — choose it and tell us which column is what.",
    "layout": "Layout of the file",
    "column": "Column in your file",
    "sample": "Example values",
    "field": "Means",
    "skip": "— Do not import —",
    "sure": "Sure",
    "unsure": "Please check",
    "remembered": "Remembered from last time",
    "missing_required": "The file needs these columns: {{fields}}",
    "missing_raw": "If the file has raw cards, map the Rank column (A–D): {{fields}}",
    "missing_graded": "If the file has graded cards, map these columns: {{fields}}",
    "duplicate": "Two columns point to the same field: {{fields}}. Choose “Do not import” for one of them.",
    "check": "Check the file",
    "back": "Choose another file",
    "rows_in_file": "{{count}} rows in the file",
    "field_of": "What the column {{column}} means"
  },
  "check": {
    "running": "Checking row {{done}} of {{total}}…",
    "queued": "Waiting to start…",
    "title": "Result of the check",
    "creates": "New products",
    "updates": "Changed products",
    "errors": "Rows with a problem",
    "warnings": "Rows to look at",
    "skips": "Unchanged / skipped",
    "no_errors": "No problems found. You can import the file.",
    "problem_rows": "Rows with a problem",
    "row": "Line in the file",
    "code": "Item",
    "what": "What is wrong",
    "download_problems": "Download only the rows with a problem",
    "download_report": "Download the file with a result per row",
    "only_good": "Import only the {{count}} rows without a problem (the other rows are skipped)",
    "fix_and_upload": "Fix the file and upload it again",
    "import": "Import",
    "import_locked": "Choose “import only the rows without a problem” or upload a fixed file.",
    "failed": "The file could not be checked: {{error}}",
    "cancel": "Stop",
    "cancelled": "Stopped."
  },
  "rank_map": {
    "title": "Old condition words in the Rank column",
    "hint": "The shop grades raw cards A / B / C / D. Choose the Rank for each word below — only this file is changed, then it is checked again.",
    "found": "In the file",
    "rows": "Rows",
    "rank": "Use Rank",
    "apply": "Use these Ranks and check again",
    "no_file": "Choose the file again to change the Rank words (the browser does not keep it after reloading).",
    "done": "{{count}} Rank(s) changed in the file",
    "rank_for": "Rank to use for “{{value}}”"
  },
  "import": {
    "running": "Importing row {{done}} of {{total}}…",
    "done_title": "Import finished",
    "done": "{{created}} new · {{updated}} changed · {{skipped}} skipped",
    "see_products": "See the imported products",
    "another": "Import another file",
    "left_page": "You can leave this page — the import goes on. Come back through “Earlier imports”."
  },
  "history": {
    "empty": "No imports yet.",
    "open": "Open",
    "rows": "{{count}} rows",
    "errors_count": "{{count}} with a problem"
  },
  "status": {
    "queued": "Waiting",
    "validating": "Checking",
    "ready": "Checked",
    "applying": "Importing",
    "done": "Imported",
    "failed": "Failed",
    "cancelled": "Stopped"
  },
  "row_status": {
    "ok": "OK",
    "warning": "OK (check)",
    "error": "Problem",
    "skipped": "Skipped"
  },
  "export": {
    "title": "Download the products",
    "hint": "All products of the shop as a CSV file. For a part of them (a saved view, a filter) use “Download” on the products list.",
    "format": "Layout",
    "native": "Full layout of this shop (can be imported again)",
    "shopify": "Shopify layout",
    "download": "Download",
    "preparing": "Preparing the file…",
    "done": "File downloaded",
    "recent": "Downloaded on this device",
    "none": "Nothing downloaded yet."
  },
  "row": {
    "required": "{{field}} is required",
    "invalid_value": "{{field}}: the value “{{value}}” is not valid",
    "invalid_money": "{{field}}: write the price in whole yen (e.g. 19000)",
    "duplicate_in_file": "{{field}} “{{value}}” appears more than once in this file (first on row {{firstRow}})",
    "game_not_found": "No game “{{value}}” — add it under Card catalog first",
    "set_not_found": "No set “{{value}}” for this game",
    "set_ambiguous": "Set “{{value}}” exists in several languages — fill set_language",
    "card_not_found": "No card {{value}} in this set (turn on “create missing cards” to add it)",
    "card_ambiguous": "Several cards have number {{value}} — fill card_name_en",
    "card_will_be_created": "Card {{value}} will be added to the card catalog",
    "category_not_found": "No category “{{value}}”",
    "invalid_reference": "{{field}}: the record this row points to no longer exists — choose another one",
    "sku_generated": "An item code will be made automatically",
    "taxable_forced_true": "Consumption tax always applies to cards — taxable was set to true",
    "price_near_cost": "The price is almost the same as the cost ({{price}} / {{cost}})",
    "seo_duplicate_ignored": "The same {{field}} is used on {{count}} rows — ignored, it will be written automatically",
    "cert_conflict": "The barcode ({{barcode}}) and the certificate number ({{certNumber}}) differ",
    "grade_conflict": "The grade in {{field}} ({{found}}) differs from grade ({{grade}})",
    "legacy_condition_alias_mapped": "“{{value}}” was read as Rank {{rank}}",
    "media_import_deferred": "Photo links were kept; photos are added when the media service is connected",
    "status_not_allowed": "status “{{value}}” is not possible here (use draft or active)",
    "variant_ambiguous": "This product has several choices (box, pack…) — fill in the item code column to choose one",
    "unchanged": "Nothing changed — skipped",
    "title_not_parsed": "The title is not in the form “Card – Set (number) (JP)” — kept as typed; link the card in the admin",
    "set_unresolved": "No set called “{{value}}” in the card catalog — the product is kept without a card link",
    "game_unresolved": "The vendor “{{value}}” is not a game of the card catalog — the product is kept without a game",
    "category_unresolved": "No category “{{value}}” — the product is kept without a category",
    "product_type_ambiguous": "Is this a graded card, a raw card or sealed? “{{value}}” does not say — fill the condition column ({{allowed}})",
    "qty_ignored_use_inventory": "The quantity ({{value}}) was not imported — receive stock in Inventory with the item code",
    "card_created_without_name": "Card {{value}} was not in the catalog and was added as “{{name}}” — give it its real name in the card catalog",
    "image_row": "Extra photo of the product on row {{firstRow}}",
    "variant_rows_not_supported": "A second choice of {{handle}} (row {{firstRow}}) — list each card as its own product",
    "card_not_found_kept": "Card {{value}} is not in this set — the product is kept without a card link",
    "not_applied_because_of_errors": "Not imported: fix the errors of this row",
    "raw_rank_required": "A single card needs its Rank (A, B, C or D)",
    "legacy_condition_alias_rejected": "“{{value}}” is not a shop rank — use A–D (suggested: {{suggested}})",
    "invalid_raw_rank": "Rank must be A, B, C or D (got “{{value}}”)",
    "graded_fields_required": "A graded card needs the grading company, the grade and the certificate number",
    "invalid_grade": "The grade must be between 1 and 10 in steps of 0.5 (PSA: whole numbers)",
    "weight_required": "Sealed products need a weight in grams",
    "duplicate_cert": "This certificate number is already listed on another product",
    "duplicate_sku": "This item code is already used",
    "duplicate_barcode": "This barcode is already used by another item",
    "invalid_ean": "The barcode is not a valid JAN/EAN-13 number",
    "reserved_handle": "This web address (handle) is reserved",
    "handle_recently_used": "This web address (handle) was used recently by another product",
    "unknown_attribute": "Unknown extra field {{field}}",
    "invalid_attribute": "The extra field {{field}} has a wrong value",
    "compare_at_type_not_allowed": "A list price (MSRP) cannot be the compare-at price of a single card",
    "price_below_cost": "The price ({{price}}) is below the cost ({{cost}})",
    "export_price_low": "The export price is far below the tax-free price",
    "invalid_cert_format": "The certificate number does not look like {{gradingCompany}}'s format",
    "similar_product_exists": "The same card in the same condition is already listed ({{count}})",
    "publish_blocked": "Saved as a draft: it can go on sale once it has a ready photo",
    "condition_type_mismatch": "The condition does not fit the product type",
    "product_type_conflict": "{{field}}: product “{{handle}}” already exists as {{existing}} — use another handle / code, or fix the product type",
    "forbidden__publish_not_allowed": "Putting products on sale (status / sales channels) needs the publish permission — leave these cells empty or ask the owner",
    "forbidden__write_not_allowed": "Your account may not add or change products",
    "forbidden__master_data_not_allowed": "{{field}}: adding a missing set or card needs the catalogue permission",
    "forbidden__consignment_scope_pending": "The consignment role may change consigned items only — not available in imports yet",
    "conflict": "{{field}} is already used by another product",
    "validation_failed__matches_auto_pattern": "{{field}}: codes in the shop's own format ({{pattern}}) are made by the system — leave it empty or use another code",
    "validation_failed__invalid_format": "{{field}}: “{{value}}” has characters that are not allowed ({{allowed}})",
    "validation_failed": "{{field}}: please check this value"
  },
  "fields": {
    "external_ref": "Your own row number / reference",
    "handle": "Name in the web address",
    "product_type": "Kind (raw / graded / sealed)",
    "game_slug": "Game",
    "set_code": "Set code",
    "set_language": "Card language",
    "set_name_en": "Set name (English)",
    "card_number": "Card number",
    "card_name_en": "Card name (English)",
    "title_en": "Title (English)",
    "title_ja": "Title (Japanese)",
    "description_en": "Description (English)",
    "detail_text": "Detail",
    "category_slug": "Category",
    "tags": "Tags",
    "status": "Status (on sale / draft)",
    "sales_channels": "Where it is sold",
    "vendor": "Maker / brand",
    "sku": "Item code",
    "barcode": "Barcode (JAN)",
    "price": "Price (yen, tax incl.)",
    "compare_at_price": "Reference price",
    "compare_at_evidence_type": "Where the reference price comes from",
    "compare_at_source_url": "Link for the reference price",
    "compare_at_methodology": "How the reference price was found",
    "export_price": "Price for overseas",
    "cost": "Purchase price",
    "weight_g": "Weight (g)",
    "taxable": "Consumption tax applies",
    "raw_rank": "Rank (A–D)",
    "raw_rank_damaged": "Damaged (Rank D)",
    "rank_note_en": "Rank note (English)",
    "grading_company": "Grading company",
    "grade": "Grade",
    "grade_label": "Grade label",
    "cert_number": "Certificate number",
    "condition_note_en": "Condition note (English)",
    "sealed_subtype": "Kind of sealed product",
    "seo_title": "Title for search engines",
    "seo_description": "Description for search engines",
    "media_urls": "Picture links",
    "game": "Game",
    "set": "Set",
    "number": "Card number",
    "language": "Card language",
    "kind": "Kind (raw / graded / sealed)",
    "rank": "Rank (A–D)",
    "grader": "Grading company",
    "cert": "Certificate number",
    "note": "Note",
    "ref": "Your own reference",
    "name": "Card name"
  }
}
